import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { TenderQuantityService } from 'src/app/Service/tender-quantity/tender-quantity.service';
import { Module } from 'src/app/Service/element-details.data.service';



@Component({
  selector: 'app-edit-configur',
  templateUrl: './edit-configur.component.html',
  styleUrls: ['./edit-configur.component.css']
})

export class EditConfigurComponent implements OnInit {
  public projectList: any[] = [];
  public tenderQuantityConfig: FieldConfig[] = [];
  public projectId!: number;
  public elementId!: number | undefined;
  public itemId!: number | undefined;
  public element!: string;
  public item!: string;
  public showLabel: boolean = false;
  public ElementForm!: FormGroup;
  public showItem: boolean = false;
  public currentActionpage!: string;
  public elementList: any[] = [];
  public itemList: any[] = [];
  public discipline!: number;
  public CommonelementData: any[] = [];
  public show: boolean = false;
  public setDisable: boolean = false;
  public setDiscipline!: string;
  public activeStatus: boolean = true;

  @ViewChild('dynamicFormComponent',{static:true}) dynamicFormComponent!: DynamicFormComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private projectInfoService: ProjectInfoService,
    public dialogRef: MatDialogRef<EditConfigurComponent>,
    private commonService: CommonService,
    private tenderQuantityService: TenderQuantityService,
    private _notificationService: NotificationService) {

  }

  ngOnInit() {
    this.getDynamicform();
    this.pageConfigure();
    this.dynamicFormComponent?.form.get('Discipline')?.valueChanges.subscribe(data => {
      if (!!data) {
        this.discipline = data.dedId;
        this.elementId = undefined;
        this.itemId = undefined;
        this.itemList = [];
        this.elementList = [];
        this.getDATA();
      } else {
        this.itemList = [];
        this.elementList = [];
        this.elementId = undefined;
        this.itemId = undefined;
      }

    });
  }

  pageConfigure() {
    if (!!this.data.value) {
      this.setDisable = true;
    }
    switch (this.data.currentpage) {
      case "Elements-Configure": {
        this.currentActionpage = this.data.currentpage;
        if (!!this.data.value) {
          this.show = true;
          this.discipline = this.data.value.disc_DED_Id;
          this.setDiscipline = this.data.value.deD_Description;
          this.elementId = this.data.value.tE_Id;
          this.element = this.data.value.tE_Description;
          this.activeStatus = (this.data.value.active_Tag == "Yes") ? true : false;
        }
        break;
      }
      case "Item-Configure": {
        this.showItem = true;
        this.currentActionpage = this.data.currentpage;
        if (!!this.data.value) {
          this.show = true;
          this.showItem = false;
          this.showLabel = true;
          this.activeStatus = (this.data.value.active_Tag == "Yes") ? true : false;
          this.discipline = this.data.value.disc_DED_Id;
          this.setDiscipline = this.data.value.deD_Description;
          this.elementId = this.data.value.tE_Id;
          this.element = this.data.value.tE_Description;
          this.item = this.data.value.tI_Description;
          this.itemId = this.data.value.tI_Id;
        }
        break;
      }
    }
  }

  masterConfigure(data?: any, action?: any, val?: any) {
    let active_status = "Y";
    if (!!val) {
      active_status = "Yes";
    }
    this.CommonelementData = data.filter((element: { disc_DED_Id: number; active_Tag: string; }) => element.disc_DED_Id == this.discipline && element.active_Tag == active_status);
    if (!!action) {
      this.CommonelementData = this.CommonelementData.filter(element => element.tE_Id == this.elementId && element.active_Tag == active_status);
    }
    let newArray = [];
    let uniqueObject:any = {};
    let objID;
    for (let i in this.CommonelementData) {
      if (!action) {
        objID = this.CommonelementData[i]['tE_Id'];
      }
      else {
        objID = this.CommonelementData[i]['tI_Id'];
      }
      uniqueObject[objID] = this.CommonelementData[i];
    }
    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }
    if (!action) {
      this.elementList = newArray;
    } else {
      this.itemList = newArray;
    }
  }

  commonGetDiscElementItemData(action?: any) {
    this.tenderQuantityService.getDiscElementItemData().subscribe(data => {
      this.masterConfigure(data, action);
    });
  }

  getDATA(onselect?: any) {
    switch (this.data.currentpage) {
      case "Elements-Configure": {
        this.commonGetDiscElementItemData();
        break;
      }
      case "Item-Configure": {
        this.tenderQuantityService.getElementProjectConfigure(this.discipline).subscribe(data => {
          this.masterConfigure(data, undefined, "Item-Configure");
        });
        break;
      }
    }
  }

  getItem(onselect?: any) {
    if (!!this.discipline && !!onselect) {
      this.elementId = onselect;
      this.commonGetDiscElementItemData("getItem");
    }
  }



  closeDialog() {
    this.dialogRef.close();
  }

  getTqSetConfig(): FieldConfig[] {
    return [
      {
        type: 'select',
        name: 'Discipline',
        label: 'Discipline',
        deDescription: 'discipline',
        module_id: Module.ScheduleDocument,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Please select discipline"
          }
        ],
        value: new BehaviorSubject(null)
      }
    ]
  };

  getDynamicform() {
    this.tenderQuantityConfig = this.getTqSetConfig();
    this.dynamicFormComponent.fields = this.tenderQuantityConfig;
    this.dynamicFormComponent.createControl();
  };

  Save() {
    switch (this.data.currentpage) {
      case "Elements-Configure": {
        if (!this.elementId) {
          this._notificationService.showPopup("Please Select Element", "Warning");
          return;
        }
        let obj = {
          "project_Id": this.commonService.getProjectId(), "disc_DED_Id": this.discipline, "tE_Id": this.elementId,
          "sort_By": 0, "active_Tag": (this.activeStatus) ? "Y" : "N", "member_Id": this.commonService.getLoggedInUserId()
        }
        this.tenderQuantityService.InsetConfigureProjectElement(obj).subscribe(data => {
          if (data.successCode == 200) {
            this._notificationService.showToast(data.successMessage, "Success");
            this.closeDialog();
            return;
          }
        });
        break;
      }
      case "Item-Configure": {
        if (!this.elementId) {
          this._notificationService.showPopup("Please Select Element", "Warning");
          return;
        }
        if (!this.itemId) {
          this._notificationService.showPopup("Please Select Item", "Warning");
          return;
        }
        let obj = {
          "project_Id": this.commonService.getProjectId(), "disc_DED_Id": this.discipline, "tE_Id": this.elementId,
          "sort_By": 0, "active_Tag": (this.activeStatus) ? "Y" : "N", "tI_Id": this.itemId,
          "member_Id": this.commonService.getLoggedInUserId()
        }
        this.tenderQuantityService.InsertConfigureProjectItem(obj).subscribe(data => {
          if (data.successCode == 200) {
            this._notificationService.showToast(data.successMessage, "Success");
            this.closeDialog();
            return;
          }
        });
        break;
      }
    }
  }
}
